export default __webpack_public_path__ + "static/media/boy.fcf7ba75.ogg";